export default __webpack_public_path__ + "static/media/news_background_right.5e8486ca.png";